var map = {
	"./af": 85449,
	"./af.d": 56022,
	"./af.d.ts": 56022,
	"./af.js": 85449,
	"./ak": 6586,
	"./ak.d": 86276,
	"./ak.d.ts": 86276,
	"./ak.js": 6586,
	"./am": 14254,
	"./am.d": 93575,
	"./am.d.ts": 93575,
	"./am.js": 14254,
	"./an": 57056,
	"./an.d": 58978,
	"./an.d.ts": 58978,
	"./an.js": 57056,
	"./ar": 73704,
	"./ar.d": 48951,
	"./ar.d.ts": 48951,
	"./ar.js": 73704,
	"./ars": 59619,
	"./ars.d": 98039,
	"./ars.d.ts": 98039,
	"./ars.js": 59619,
	"./as": 97818,
	"./as.d": 40560,
	"./as.d.ts": 40560,
	"./as.js": 97818,
	"./asa": 2898,
	"./asa.d": 1604,
	"./asa.d.ts": 1604,
	"./asa.js": 2898,
	"./ast": 7535,
	"./ast.d": 12216,
	"./ast.d.ts": 12216,
	"./ast.js": 7535,
	"./az": 81802,
	"./az.d": 44774,
	"./az.d.ts": 44774,
	"./az.js": 81802,
	"./bal": 67598,
	"./bal.d": 49425,
	"./bal.d.ts": 49425,
	"./bal.js": 67598,
	"./be": 62200,
	"./be.d": 91071,
	"./be.d.ts": 91071,
	"./be.js": 62200,
	"./bem": 29613,
	"./bem.d": 57393,
	"./bem.d.ts": 57393,
	"./bem.js": 29613,
	"./bez": 79732,
	"./bez.d": 90519,
	"./bez.d.ts": 90519,
	"./bez.js": 79732,
	"./bg": 6822,
	"./bg.d": 80517,
	"./bg.d.ts": 80517,
	"./bg.js": 6822,
	"./bho": 34135,
	"./bho.d": 13642,
	"./bho.d.ts": 13642,
	"./bho.js": 34135,
	"./bm": 46870,
	"./bm.d": 33697,
	"./bm.d.ts": 33697,
	"./bm.js": 46870,
	"./bn": 41168,
	"./bn.d": 7742,
	"./bn.d.ts": 7742,
	"./bn.js": 41168,
	"./bo": 75004,
	"./bo.d": 99200,
	"./bo.d.ts": 99200,
	"./bo.js": 75004,
	"./br": 29132,
	"./br.d": 88174,
	"./br.d.ts": 88174,
	"./br.js": 29132,
	"./brx": 51267,
	"./brx.d": 64024,
	"./brx.d.ts": 64024,
	"./brx.js": 51267,
	"./bs": 83758,
	"./bs.d": 65458,
	"./bs.d.ts": 65458,
	"./bs.js": 83758,
	"./ca": 35178,
	"./ca.d": 7233,
	"./ca.d.ts": 7233,
	"./ca.js": 35178,
	"./ce": 58459,
	"./ce.d": 95655,
	"./ce.d.ts": 95655,
	"./ce.js": 58459,
	"./ceb": 23941,
	"./ceb.d": 44789,
	"./ceb.d.ts": 44789,
	"./ceb.js": 23941,
	"./cgg": 49565,
	"./cgg.d": 53031,
	"./cgg.d.ts": 53031,
	"./cgg.js": 49565,
	"./chr": 91604,
	"./chr.d": 7447,
	"./chr.d.ts": 7447,
	"./chr.js": 91604,
	"./ckb": 93055,
	"./ckb.d": 73881,
	"./ckb.d.ts": 73881,
	"./ckb.js": 93055,
	"./cs": 54618,
	"./cs.d": 62644,
	"./cs.d.ts": 62644,
	"./cs.js": 54618,
	"./cy": 25079,
	"./cy.d": 75069,
	"./cy.d.ts": 75069,
	"./cy.js": 25079,
	"./da": 73428,
	"./da.d": 52030,
	"./da.d.ts": 52030,
	"./da.js": 73428,
	"./de": 19767,
	"./de.d": 96877,
	"./de.d.ts": 96877,
	"./de.js": 19767,
	"./doi": 91905,
	"./doi.d": 19985,
	"./doi.d.ts": 19985,
	"./doi.js": 91905,
	"./dsb": 73813,
	"./dsb.d": 51549,
	"./dsb.d.ts": 51549,
	"./dsb.js": 73813,
	"./dv": 54171,
	"./dv.d": 31501,
	"./dv.d.ts": 31501,
	"./dv.js": 54171,
	"./dz": 34476,
	"./dz.d": 24314,
	"./dz.d.ts": 24314,
	"./dz.js": 34476,
	"./ee": 71001,
	"./ee.d": 33247,
	"./ee.d.ts": 33247,
	"./ee.js": 71001,
	"./el": 47258,
	"./el.d": 20779,
	"./el.d.ts": 20779,
	"./el.js": 47258,
	"./en": 17689,
	"./en.d": 36552,
	"./en.d.ts": 36552,
	"./en.js": 17689,
	"./eo": 31837,
	"./eo.d": 25707,
	"./eo.d.ts": 25707,
	"./eo.js": 31837,
	"./es": 96153,
	"./es.d": 7943,
	"./es.d.ts": 7943,
	"./es.js": 96153,
	"./et": 17371,
	"./et.d": 89250,
	"./et.d.ts": 89250,
	"./et.js": 17371,
	"./eu": 55400,
	"./eu.d": 47225,
	"./eu.d.ts": 47225,
	"./eu.js": 55400,
	"./fa": 15118,
	"./fa.d": 28527,
	"./fa.d.ts": 28527,
	"./fa.js": 15118,
	"./ff": 84333,
	"./ff.d": 87557,
	"./ff.d.ts": 87557,
	"./ff.js": 84333,
	"./fi": 570,
	"./fi.d": 56993,
	"./fi.d.ts": 56993,
	"./fi.js": 570,
	"./fil": 79707,
	"./fil.d": 4613,
	"./fil.d.ts": 4613,
	"./fil.js": 79707,
	"./fo": 12443,
	"./fo.d": 81556,
	"./fo.d.ts": 81556,
	"./fo.js": 12443,
	"./fr": 60463,
	"./fr.d": 11479,
	"./fr.d.ts": 11479,
	"./fr.js": 60463,
	"./fur": 33306,
	"./fur.d": 31929,
	"./fur.d.ts": 31929,
	"./fur.js": 33306,
	"./fy": 90299,
	"./fy.d": 37140,
	"./fy.d.ts": 37140,
	"./fy.js": 90299,
	"./ga": 37639,
	"./ga.d": 62964,
	"./ga.d.ts": 62964,
	"./ga.js": 37639,
	"./gd": 67865,
	"./gd.d": 69631,
	"./gd.d.ts": 69631,
	"./gd.js": 67865,
	"./gl": 10927,
	"./gl.d": 41144,
	"./gl.d.ts": 41144,
	"./gl.js": 10927,
	"./gsw": 31792,
	"./gsw.d": 58917,
	"./gsw.d.ts": 58917,
	"./gsw.js": 31792,
	"./gu": 29177,
	"./gu.d": 33712,
	"./gu.d.ts": 33712,
	"./gu.js": 29177,
	"./guw": 3496,
	"./guw.d": 24812,
	"./guw.d.ts": 24812,
	"./guw.js": 3496,
	"./gv": 15480,
	"./gv.d": 77786,
	"./gv.d.ts": 77786,
	"./gv.js": 15480,
	"./ha": 28732,
	"./ha.d": 46198,
	"./ha.d.ts": 46198,
	"./ha.js": 28732,
	"./haw": 19243,
	"./haw.d": 67822,
	"./haw.d.ts": 67822,
	"./haw.js": 19243,
	"./he": 44313,
	"./he.d": 49556,
	"./he.d.ts": 49556,
	"./he.js": 44313,
	"./hi": 1895,
	"./hi.d": 94210,
	"./hi.d.ts": 94210,
	"./hi.js": 1895,
	"./hnj": 40911,
	"./hnj.d": 19071,
	"./hnj.d.ts": 19071,
	"./hnj.js": 40911,
	"./hr": 67541,
	"./hr.d": 85766,
	"./hr.d.ts": 85766,
	"./hr.js": 67541,
	"./hsb": 68029,
	"./hsb.d": 44377,
	"./hsb.d.ts": 44377,
	"./hsb.js": 68029,
	"./hu": 42765,
	"./hu.d": 51141,
	"./hu.d.ts": 51141,
	"./hu.js": 42765,
	"./hy": 33623,
	"./hy.d": 83417,
	"./hy.d.ts": 83417,
	"./hy.js": 33623,
	"./ia": 32881,
	"./ia.d": 85537,
	"./ia.d.ts": 85537,
	"./ia.js": 32881,
	"./id": 10028,
	"./id.d": 67844,
	"./id.d.ts": 67844,
	"./id.js": 10028,
	"./ig": 92593,
	"./ig.d": 95695,
	"./ig.d.ts": 95695,
	"./ig.js": 92593,
	"./ii": 18604,
	"./ii.d": 63608,
	"./ii.d.ts": 63608,
	"./ii.js": 18604,
	"./io": 14742,
	"./io.d": 8333,
	"./io.d.ts": 8333,
	"./io.js": 14742,
	"./is": 37995,
	"./is.d": 28687,
	"./is.d.ts": 28687,
	"./is.js": 37995,
	"./it": 37305,
	"./it.d": 36175,
	"./it.d.ts": 36175,
	"./it.js": 37305,
	"./iu": 84413,
	"./iu.d": 5337,
	"./iu.d.ts": 5337,
	"./iu.js": 84413,
	"./ja": 7021,
	"./ja.d": 28767,
	"./ja.d.ts": 28767,
	"./ja.js": 7021,
	"./jbo": 4084,
	"./jbo.d": 43667,
	"./jbo.d.ts": 43667,
	"./jbo.js": 4084,
	"./jgo": 3876,
	"./jgo.d": 16838,
	"./jgo.d.ts": 16838,
	"./jgo.js": 3876,
	"./jmc": 50805,
	"./jmc.d": 36008,
	"./jmc.d.ts": 36008,
	"./jmc.js": 50805,
	"./jv": 19346,
	"./jv.d": 47046,
	"./jv.d.ts": 47046,
	"./jv.js": 19346,
	"./jw": 84326,
	"./jw.d": 74952,
	"./jw.d.ts": 74952,
	"./jw.js": 84326,
	"./ka": 42214,
	"./ka.d": 18438,
	"./ka.d.ts": 18438,
	"./ka.js": 42214,
	"./kab": 96691,
	"./kab.d": 27714,
	"./kab.d.ts": 27714,
	"./kab.js": 96691,
	"./kaj": 61785,
	"./kaj.d": 66239,
	"./kaj.d.ts": 66239,
	"./kaj.js": 61785,
	"./kcg": 95130,
	"./kcg.d": 82553,
	"./kcg.d.ts": 82553,
	"./kcg.js": 95130,
	"./kde": 17201,
	"./kde.d": 64404,
	"./kde.d.ts": 64404,
	"./kde.js": 17201,
	"./kea": 62408,
	"./kea.d": 88412,
	"./kea.d.ts": 88412,
	"./kea.js": 62408,
	"./kk": 14281,
	"./kk.d": 45770,
	"./kk.d.ts": 45770,
	"./kk.js": 14281,
	"./kkj": 89402,
	"./kkj.d": 47189,
	"./kkj.d.ts": 47189,
	"./kkj.js": 89402,
	"./kl": 82226,
	"./kl.d": 74233,
	"./kl.d.ts": 74233,
	"./kl.js": 82226,
	"./km": 65701,
	"./km.d": 95223,
	"./km.d.ts": 95223,
	"./km.js": 65701,
	"./kn": 60813,
	"./kn.d": 55144,
	"./kn.d.ts": 55144,
	"./kn.js": 60813,
	"./ko": 7402,
	"./ko.d": 81576,
	"./ko.d.ts": 81576,
	"./ko.js": 7402,
	"./ks": 33938,
	"./ks.d": 9812,
	"./ks.d.ts": 9812,
	"./ks.js": 33938,
	"./ksb": 50051,
	"./ksb.d": 89566,
	"./ksb.d.ts": 89566,
	"./ksb.js": 50051,
	"./ksh": 27039,
	"./ksh.d": 79075,
	"./ksh.d.ts": 79075,
	"./ksh.js": 27039,
	"./ku": 22155,
	"./ku.d": 30398,
	"./ku.d.ts": 30398,
	"./ku.js": 22155,
	"./kw": 54960,
	"./kw.d": 48515,
	"./kw.d.ts": 48515,
	"./kw.js": 54960,
	"./ky": 89977,
	"./ky.d": 18527,
	"./ky.d.ts": 18527,
	"./ky.js": 89977,
	"./lag": 19329,
	"./lag.d": 40153,
	"./lag.d.ts": 40153,
	"./lag.js": 19329,
	"./lb": 90227,
	"./lb.d": 17465,
	"./lb.d.ts": 17465,
	"./lb.js": 90227,
	"./lg": 54349,
	"./lg.d": 85120,
	"./lg.d.ts": 85120,
	"./lg.js": 54349,
	"./lij": 43921,
	"./lij.d": 6190,
	"./lij.d.ts": 6190,
	"./lij.js": 43921,
	"./lkt": 39615,
	"./lkt.d": 3230,
	"./lkt.d.ts": 3230,
	"./lkt.js": 39615,
	"./ln": 8625,
	"./ln.d": 28131,
	"./ln.d.ts": 28131,
	"./ln.js": 8625,
	"./lo": 58448,
	"./lo.d": 60423,
	"./lo.d.ts": 60423,
	"./lo.js": 58448,
	"./lt": 23969,
	"./lt.d": 90710,
	"./lt.d.ts": 90710,
	"./lt.js": 23969,
	"./lv": 49555,
	"./lv.d": 16835,
	"./lv.d.ts": 16835,
	"./lv.js": 49555,
	"./mas": 98748,
	"./mas.d": 27898,
	"./mas.d.ts": 27898,
	"./mas.js": 98748,
	"./mg": 49959,
	"./mg.d": 90243,
	"./mg.d.ts": 90243,
	"./mg.js": 49959,
	"./mgo": 25570,
	"./mgo.d": 22644,
	"./mgo.d.ts": 22644,
	"./mgo.js": 25570,
	"./mk": 46978,
	"./mk.d": 42556,
	"./mk.d.ts": 42556,
	"./mk.js": 46978,
	"./ml": 87250,
	"./ml.d": 96416,
	"./ml.d.ts": 96416,
	"./ml.js": 87250,
	"./mn": 74063,
	"./mn.d": 35644,
	"./mn.d.ts": 35644,
	"./mn.js": 74063,
	"./mo": 89324,
	"./mo.d": 77641,
	"./mo.d.ts": 77641,
	"./mo.js": 89324,
	"./mr": 31397,
	"./mr.d": 31910,
	"./mr.d.ts": 31910,
	"./mr.js": 31397,
	"./ms": 27648,
	"./ms.d": 56524,
	"./ms.d.ts": 56524,
	"./ms.js": 27648,
	"./mt": 781,
	"./mt.d": 86738,
	"./mt.d.ts": 86738,
	"./mt.js": 781,
	"./my": 14134,
	"./my.d": 79324,
	"./my.d.ts": 79324,
	"./my.js": 14134,
	"./nah": 79312,
	"./nah.d": 6294,
	"./nah.d.ts": 6294,
	"./nah.js": 79312,
	"./naq": 82079,
	"./naq.d": 52561,
	"./naq.d.ts": 52561,
	"./naq.js": 82079,
	"./nb": 25023,
	"./nb.d": 68293,
	"./nb.d.ts": 68293,
	"./nb.js": 25023,
	"./nd": 73738,
	"./nd.d": 29342,
	"./nd.d.ts": 29342,
	"./nd.js": 73738,
	"./ne": 64436,
	"./ne.d": 86991,
	"./ne.d.ts": 86991,
	"./ne.js": 64436,
	"./nl": 58670,
	"./nl.d": 90896,
	"./nl.d.ts": 90896,
	"./nl.js": 58670,
	"./nn": 3171,
	"./nn.d": 91499,
	"./nn.d.ts": 91499,
	"./nn.js": 3171,
	"./nnh": 29010,
	"./nnh.d": 42571,
	"./nnh.d.ts": 42571,
	"./nnh.js": 29010,
	"./no": 29483,
	"./no.d": 51397,
	"./no.d.ts": 51397,
	"./no.js": 29483,
	"./nqo": 93810,
	"./nqo.d": 75753,
	"./nqo.d.ts": 75753,
	"./nqo.js": 93810,
	"./nr": 21982,
	"./nr.d": 17330,
	"./nr.d.ts": 17330,
	"./nr.js": 21982,
	"./nso": 80269,
	"./nso.d": 28595,
	"./nso.d.ts": 28595,
	"./nso.js": 80269,
	"./ny": 22313,
	"./ny.d": 92070,
	"./ny.d.ts": 92070,
	"./ny.js": 22313,
	"./nyn": 80983,
	"./nyn.d": 84409,
	"./nyn.d.ts": 84409,
	"./nyn.js": 80983,
	"./om": 15043,
	"./om.d": 36564,
	"./om.d.ts": 36564,
	"./om.js": 15043,
	"./or": 22138,
	"./or.d": 5853,
	"./or.d.ts": 5853,
	"./or.js": 22138,
	"./os": 25817,
	"./os.d": 92039,
	"./os.d.ts": 92039,
	"./os.js": 25817,
	"./osa": 56767,
	"./osa.d": 48205,
	"./osa.d.ts": 48205,
	"./osa.js": 56767,
	"./pa": 50684,
	"./pa.d": 93621,
	"./pa.d.ts": 93621,
	"./pa.js": 50684,
	"./pap": 23841,
	"./pap.d": 63090,
	"./pap.d.ts": 63090,
	"./pap.js": 23841,
	"./pcm": 81463,
	"./pcm.d": 85437,
	"./pcm.d.ts": 85437,
	"./pcm.js": 81463,
	"./pl": 53026,
	"./pl.d": 25126,
	"./pl.d.ts": 25126,
	"./pl.js": 53026,
	"./prg": 4298,
	"./prg.d": 87099,
	"./prg.d.ts": 87099,
	"./prg.js": 4298,
	"./ps": 49977,
	"./ps.d": 72816,
	"./ps.d.ts": 72816,
	"./ps.js": 49977,
	"./pt": 19370,
	"./pt-PT": 29445,
	"./pt-PT.d": 42831,
	"./pt-PT.d.ts": 42831,
	"./pt-PT.js": 29445,
	"./pt.d": 85159,
	"./pt.d.ts": 85159,
	"./pt.js": 19370,
	"./rm": 53325,
	"./rm.d": 19220,
	"./rm.d.ts": 19220,
	"./rm.js": 53325,
	"./ro": 97658,
	"./ro.d": 33270,
	"./ro.d.ts": 33270,
	"./ro.js": 97658,
	"./rof": 43754,
	"./rof.d": 87848,
	"./rof.d.ts": 87848,
	"./rof.js": 43754,
	"./ru": 45542,
	"./ru.d": 42524,
	"./ru.d.ts": 42524,
	"./ru.js": 45542,
	"./rwk": 90319,
	"./rwk.d": 46128,
	"./rwk.d.ts": 46128,
	"./rwk.js": 90319,
	"./sah": 23767,
	"./sah.d": 82369,
	"./sah.d.ts": 82369,
	"./sah.js": 23767,
	"./saq": 83662,
	"./saq.d": 22708,
	"./saq.d.ts": 22708,
	"./saq.js": 83662,
	"./sat": 52865,
	"./sat.d": 82575,
	"./sat.d.ts": 82575,
	"./sat.js": 52865,
	"./sc": 25843,
	"./sc.d": 50906,
	"./sc.d.ts": 50906,
	"./sc.js": 25843,
	"./scn": 57605,
	"./scn.d": 21542,
	"./scn.d.ts": 21542,
	"./scn.js": 57605,
	"./sd": 13093,
	"./sd.d": 96524,
	"./sd.d.ts": 96524,
	"./sd.js": 13093,
	"./sdh": 89994,
	"./sdh.d": 11329,
	"./sdh.d.ts": 11329,
	"./sdh.js": 89994,
	"./se": 45360,
	"./se.d": 88211,
	"./se.d.ts": 88211,
	"./se.js": 45360,
	"./seh": 40617,
	"./seh.d": 1097,
	"./seh.d.ts": 1097,
	"./seh.js": 40617,
	"./ses": 55240,
	"./ses.d": 5135,
	"./ses.d.ts": 5135,
	"./ses.js": 55240,
	"./sg": 10172,
	"./sg.d": 45658,
	"./sg.d.ts": 45658,
	"./sg.js": 10172,
	"./sh": 81571,
	"./sh.d": 39149,
	"./sh.d.ts": 39149,
	"./sh.js": 81571,
	"./shi": 47041,
	"./shi.d": 47372,
	"./shi.d.ts": 47372,
	"./shi.js": 47041,
	"./si": 4379,
	"./si.d": 6653,
	"./si.d.ts": 6653,
	"./si.js": 4379,
	"./sk": 50685,
	"./sk.d": 41835,
	"./sk.d.ts": 41835,
	"./sk.js": 50685,
	"./sl": 55635,
	"./sl.d": 43479,
	"./sl.d.ts": 43479,
	"./sl.js": 55635,
	"./sma": 18035,
	"./sma.d": 18661,
	"./sma.d.ts": 18661,
	"./sma.js": 18035,
	"./smi": 47250,
	"./smi.d": 75357,
	"./smi.d.ts": 75357,
	"./smi.js": 47250,
	"./smj": 79041,
	"./smj.d": 50484,
	"./smj.d.ts": 50484,
	"./smj.js": 79041,
	"./smn": 96200,
	"./smn.d": 27795,
	"./smn.d.ts": 27795,
	"./smn.js": 96200,
	"./sms": 91250,
	"./sms.d": 73623,
	"./sms.d.ts": 73623,
	"./sms.js": 91250,
	"./sn": 97303,
	"./sn.d": 4417,
	"./sn.d.ts": 4417,
	"./sn.js": 97303,
	"./so": 13966,
	"./so.d": 24459,
	"./so.d.ts": 24459,
	"./so.js": 13966,
	"./sq": 86685,
	"./sq.d": 74408,
	"./sq.d.ts": 74408,
	"./sq.js": 86685,
	"./sr": 91920,
	"./sr.d": 64901,
	"./sr.d.ts": 64901,
	"./sr.js": 91920,
	"./ss": 3447,
	"./ss.d": 39879,
	"./ss.d.ts": 39879,
	"./ss.js": 3447,
	"./ssy": 42799,
	"./ssy.d": 28400,
	"./ssy.d.ts": 28400,
	"./ssy.js": 42799,
	"./st": 6686,
	"./st.d": 50549,
	"./st.d.ts": 50549,
	"./st.js": 6686,
	"./su": 48422,
	"./su.d": 69337,
	"./su.d.ts": 69337,
	"./su.js": 48422,
	"./sv": 33187,
	"./sv.d": 65065,
	"./sv.d.ts": 65065,
	"./sv.js": 33187,
	"./sw": 47755,
	"./sw.d": 46509,
	"./sw.d.ts": 46509,
	"./sw.js": 47755,
	"./syr": 30379,
	"./syr.d": 23235,
	"./syr.d.ts": 23235,
	"./syr.js": 30379,
	"./ta": 97842,
	"./ta.d": 4880,
	"./ta.d.ts": 4880,
	"./ta.js": 97842,
	"./te": 70156,
	"./te.d": 14787,
	"./te.d.ts": 14787,
	"./te.js": 70156,
	"./teo": 3731,
	"./teo.d": 78099,
	"./teo.d.ts": 78099,
	"./teo.js": 3731,
	"./th": 81104,
	"./th.d": 94685,
	"./th.d.ts": 94685,
	"./th.js": 81104,
	"./ti": 57274,
	"./ti.d": 64946,
	"./ti.d.ts": 64946,
	"./ti.js": 57274,
	"./tig": 26386,
	"./tig.d": 72680,
	"./tig.d.ts": 72680,
	"./tig.js": 26386,
	"./tk": 68762,
	"./tk.d": 24110,
	"./tk.d.ts": 24110,
	"./tk.js": 68762,
	"./tl": 90012,
	"./tl.d": 74909,
	"./tl.d.ts": 74909,
	"./tl.js": 90012,
	"./tn": 71539,
	"./tn.d": 80085,
	"./tn.d.ts": 80085,
	"./tn.js": 71539,
	"./to": 73165,
	"./to.d": 85539,
	"./to.d.ts": 85539,
	"./to.js": 73165,
	"./tpi": 51792,
	"./tpi.d": 78274,
	"./tpi.d.ts": 78274,
	"./tpi.js": 51792,
	"./tr": 68551,
	"./tr.d": 38015,
	"./tr.d.ts": 38015,
	"./tr.js": 68551,
	"./ts": 48282,
	"./ts.d": 87306,
	"./ts.d.ts": 87306,
	"./ts.js": 48282,
	"./tzm": 15160,
	"./tzm.d": 46536,
	"./tzm.d.ts": 46536,
	"./tzm.js": 15160,
	"./ug": 87276,
	"./ug.d": 59860,
	"./ug.d.ts": 59860,
	"./ug.js": 87276,
	"./uk": 38182,
	"./uk.d": 22837,
	"./uk.d.ts": 22837,
	"./uk.js": 38182,
	"./und": 83610,
	"./und.d": 60427,
	"./und.d.ts": 60427,
	"./und.js": 83610,
	"./ur": 15196,
	"./ur.d": 10404,
	"./ur.d.ts": 10404,
	"./ur.js": 15196,
	"./uz": 20411,
	"./uz.d": 5584,
	"./uz.d.ts": 5584,
	"./uz.js": 20411,
	"./ve": 26106,
	"./ve.d": 59780,
	"./ve.d.ts": 59780,
	"./ve.js": 26106,
	"./vi": 23409,
	"./vi.d": 6721,
	"./vi.d.ts": 6721,
	"./vi.js": 23409,
	"./vo": 12293,
	"./vo.d": 65441,
	"./vo.d.ts": 65441,
	"./vo.js": 12293,
	"./vun": 93765,
	"./vun.d": 60079,
	"./vun.d.ts": 60079,
	"./vun.js": 93765,
	"./wa": 3849,
	"./wa.d": 24102,
	"./wa.d.ts": 24102,
	"./wa.js": 3849,
	"./wae": 64491,
	"./wae.d": 56179,
	"./wae.d.ts": 56179,
	"./wae.js": 64491,
	"./wo": 23018,
	"./wo.d": 55597,
	"./wo.d.ts": 55597,
	"./wo.js": 23018,
	"./xh": 85060,
	"./xh.d": 7370,
	"./xh.d.ts": 7370,
	"./xh.js": 85060,
	"./xog": 30256,
	"./xog.d": 34770,
	"./xog.d.ts": 34770,
	"./xog.js": 30256,
	"./yi": 59506,
	"./yi.d": 34829,
	"./yi.d.ts": 34829,
	"./yi.js": 59506,
	"./yo": 21005,
	"./yo.d": 96370,
	"./yo.d.ts": 96370,
	"./yo.js": 21005,
	"./yue": 37333,
	"./yue.d": 82177,
	"./yue.d.ts": 82177,
	"./yue.js": 37333,
	"./zh": 96364,
	"./zh.d": 14407,
	"./zh.d.ts": 14407,
	"./zh.js": 96364,
	"./zu": 3673,
	"./zu.d": 25772,
	"./zu.d.ts": 25772,
	"./zu.js": 3673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80740;